import { ArrowDown, ArrowUp } from 'lucide-react';
import React from 'react';

export type MetricType = 'currency' | 'percent' | 'number';

export interface MetricCardProps {
  title: string;
  value: number;
  subtext?: string;
  type?: MetricType;
  className?: string;
  percentChange?: number;
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, subtext, type = 'number', className = '', percentChange }) => {
  const formatValue = (val: number, valueType: MetricType): string => {
    switch (valueType) {
      case 'currency':
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(val);

      case 'percent':
        return new Intl.NumberFormat('en-US', {
          style: 'percent',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(val / 100);

      case 'number':
      default:
        return new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(val);
    }
  };

  return (
    <div className={`bg-white rounded-lg shadow-md p-6 ${className} w-fit`}>
      <div className='flex justify-between items-center'>
        <div className="text-sm text-gray-500 mb-2 font-bold">
          {title}
        </div>
        {percentChange && (
          <div className='text-xs text-gray-500 mb-2 font-normal flex items-center'>
            {percentChange > 0 ? (<ArrowUp className="w-3 h-3 text-green-600 mr-1" />) : (<ArrowDown className="w-3 h-3 text-red-600 mr-1" />)}
            {formatValue(Math.abs(percentChange), 'percent')}
          </div>
        )}

      </div>

      <div className="text-4xl font-bold text-gray-900">
        {formatValue(value, type)}
      </div>
      <div className="text-xs text-gray-500">
        {subtext}
      </div>
    </div>
  );
};

export default MetricCard;
